/**
 * @summary The Default Header For the site, This is also used as a fallback.
 */
import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'utils/classnames';
import MainNav from 'components/sections/mainNav/MainNav';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import ToolTip from 'components/base/toolTip/ToolTip';
import Logo from 'components/base/logo/Logo';
import GlobalContext from 'hooks/contexts/GlobalContext';

function DefaultSiteHeader({
  headertext = '',
  menuItems,
  siteName,
  innerRef,
  logoLink,
}) {
  const headerClass = cx({
    header: true,
    'header--hasHeaderText': !!headertext,
  });

  const {
    siteMeta: { disclosure },
  } = useContext(GlobalContext);

  return (
    <header className={headerClass} ref={innerRef}>
      <div className="header__inner">
        <Logo siteName={siteName} logoLink={logoLink} />
        {menuItems?.length > 0 && (
          <nav className="header__nav" role="navigation" aria-label="Main">
            <MainNav menuItems={menuItems} />
          </nav>
        )}
        {headertext && (
          <div className="header__secondary">
            <Wysiwyg content={headertext} />
          </div>
        )}
        {disclosure && (
          <div className="header__disclosure">
            <ToolTip label="Advertiser Disclosure" positioning="bottom">
              <Wysiwyg isClean content={disclosure} />
            </ToolTip>
          </div>
        )}
      </div>
    </header>
  );
}

DefaultSiteHeader.propTypes = {
  headertext: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  menuItems: PropTypes.array,
  siteName: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  logoLink: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
};

const ForwardedDefaultSiteHeader = forwardRef((props, ref) => {
  const { headertext, menuItems, siteName, logoLink } = props;
  return (
    <DefaultSiteHeader
      headertext={headertext}
      menuItems={menuItems}
      siteName={siteName}
      logoLink={logoLink}
      innerRef={ref}
    />
  );
});

ForwardedDefaultSiteHeader.displayName = 'DefaultSiteHeader';

export default ForwardedDefaultSiteHeader;
